import { render } from "./WaveEdgeDropdown.vue?vue&type=template&id=575c0a6b"
import script from "./WaveEdgeDropdown.vue?vue&type=script&lang=js"
export * from "./WaveEdgeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__